import React from "react";
import "./AllProduct.css"; // Importing the CSS file
import { productimages } from "./AllProductimg/AllProductImage";
import { Helmet } from "react-helmet-async";

const softwareCategories = [
  "Advocate", "Adsrock", "Apartment", "Bank", "Bet", "Bid", "Billing", "Booking",
  "Bus Booking", "Business Suite", "Cab", "Card", "Casino", "Chat", "Classifieds",
  "Clinic", "CMS", "Coin", "Colour Prediction Website", "Coupon", "Courier", "CRM",
  "Digital Product", "Directory", "Doctor Appointment", "Doctor Listing", "Ecommerce",
  "ERP", "Escrow", "Email Marketing", "Exam", "Exchange", "Fans Only", "Food Delivery",
  "Freelancer", "Fund", "Gamers Arena", "Groomify", "Hospital", "Hotel Booking", "HRM",
  "Influencer", "Institute", "Inventory", "Investment", "Invoice", "ISP", "Job",
  "Laboratory", "Lead", "LMS", "Loan", "Lottery", "Matrimony", "Meeting", "Mining", "MLM",
  "News", "NFT", "NGO", "PMS", "POS", "PTC", "QR Code", "QR Menu", "Rate", "Real Estate",
  "Recharge", "Restaurant", "School", "Sender", "Service", "SMM", "SMS", "Social",
  "StocLab", "Store", "Support", "Survey", "Teleman", "Text to Speech", "Tool", "Trade",
  "Travel", "Tailor", "URL Shortener", "Vcard", "Video Streaming", "Video Editing",
  "Gate Pass", "Wallet"
];

const AllProducts = () => {
  return (
    <>

      <Helmet>
        <title>All Software Products & Digital Solutions We Offer</title>
        <meta
          name="description"
          content="Explore all our software products — ERP, CRM, e-commerce, medical, analytics, and more — designed to help your business run smarter and grow faster."
        />
        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkattech.com/all-products" />
        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkattech.com/all-products" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkattech.com/all-products" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkattech.com/all-products" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkattech.com/all-products" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkattech.com/all-products" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkattech.com/all-products" />

      </Helmet>


      <div className="fullcontrol">


        <h1 className="headingtag">Explore All Our Software & Digital Products</h1>

        <div className="products-container">
          {softwareCategories.map((category, index) => (
            <div key={index} className="product-card">
              <img
                src={productimages[`img${index + 1}`] || "https://placehold.co/150x150"}
                alt={category}
                className="product-image"
              />
              <h3 className="product-title">{category}</h3>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AllProducts;
